export default "/react/tiktokIcon-4f0d58a4.svg";